import { useQuery } from "@tanstack/react-query";

import { getProfile } from "../core/profile.core";
import { AdminUserType, Me } from "../types/profile";

export default function useProfile() {
  const rst = useQuery({
    queryKey: ["me"],
    queryFn: getProfile,
    refetchInterval: 1000 * 60 * 10, // 10 minutes
  });

  return { ...rst, isSuperAdmin: isSuperAdmin(rst.data) };
}

function isSuperAdmin(profile: Me | null | undefined) {
  if (!profile) return false;
  return profile.type === AdminUserType.superAdmin;
}
